import { put } from 'app/utils/axios/kheti'
import { FarmerDetails } from "../models/farmer";

const updateFarmerDetails = async (
  farmerId: string | number,
  body: Record<string, any>
) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/detail`;
    await put<FarmerDetails>(url, body);
    return true;
  } catch (e) {
    console.log("error", e);
    console.error(e);
    return false;
  }
};

export default updateFarmerDetails;
